import { useEffect, useState } from "react";
import client from "../api/client";
const companyId = () => Number(localStorage.getItem("companyId") || 0);
const val = (r, ...k) =>
  k.map((x) => r?.[x]).find((x) => x !== undefined && x !== null) ?? 0;
const money = (v) =>
  Number(v || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
export default function InventoryDashboardPage() {
  const [data, setData] = useState({});
  useEffect(() => {
    client
      .get("/inventory/dashboard", {
        params: { companyId: companyId() || undefined },
      })
      .then((r) => setData(r.data || {}));
  }, []);
  const cards = [
    ["Total Items", val(data, "TotalItems", "totalItems")],
    ["Warehouses", val(data, "TotalWarehouses", "totalWarehouses")],
    [
      "Stock Value",
      "₹ " + money(val(data, "TotalStockValue", "totalStockValue")),
    ],
  ];
  return (
    <div className="container-fluid py-2" style={{ fontSize: 11, padding: 0 }}>
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 2px 10px rgba(0,0,0,.08)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "linear-gradient(90deg,#0b4f4a,#0f766e)",
            color: "#fff",
            padding: "8px 12px",
          }}
        >
          <h6 style={{ fontSize: 13, fontWeight: 700, margin: 0 }}>
            Inventory Dashboard
          </h6>
          <div style={{ fontSize: 10, opacity: 0.85 }}>Inventory summary</div>
        </div>
        <div className="row g-2 p-2">
          {cards.map(([t, v]) => (
            <div className="col-md-3" key={t}>
              <div
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: 12,
                  padding: 12,
                  background: "#f8fafc",
                }}
              >
                <div className="text-muted fw-bold" style={{ fontSize: 10 }}>
                  {t}
                </div>
                <div
                  style={{ fontSize: 18, fontWeight: 800, color: "#0f766e" }}
                >
                  {v}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
